// extracted by mini-css-extract-plugin
module.exports = {"About":"About_About__RD_cn"};